import React from 'react';
import { Link } from 'react-router-dom';
import withTracker from '../../withTracker';

const ClientThankYou = props => {
  return (
    <div className="on-boarding-thank-you">
      <div className="on-boarding-thank-you__wrap">
        <div className="on-boarding__h1">Thank You!</div>
        <div className="on-boarding__p">
          Please click the link within your email confirmation so we can get
          started. The Culinistas will reach out with a brief phone call to
          discuss your first service.
        </div>
        <div className="on-boarding-thank-you__cta">
          <Link to="/login" className="btn btn--solid-blue">
            Log In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default withTracker(ClientThankYou);



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientThankYou.js